<template>
  <div class="flex flex-col items-center">
    <div
      class="size-12 rounded-full border shadow flex items-center justify-center text-xl transition-colors"
      :class="ready ? 'border-green-300 bg-green-100 text-green-500' : 'border-red-300 bg-red-100 text-red-500'"
    >
      <i :class="icon"></i>
    </div>
    <span class="text-xs text-gray-700 mt-1">{{ name ?? '' }}</span>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  name?: string;
  icon: string;
  ready: boolean;
}>();
</script>

<style scoped></style>
